import { Component, OnInit } from "@angular/core";
import { trigger, style, transition, animate } from "@angular/animations";
import { SmartAppBannerService } from "./smart-app-banner.service";

@Component({
  selector: "app-smart-app-banner",
  templateUrl: "./smart-app-banner.component.html",
  styleUrls: ["./smart-app-banner.component.scss"],
  animations: [
    trigger("slideDown", [
      transition(":enter", [
        style({ transform: "translateY(-100%)" }),
        animate("300ms ease-out", style({ transform: "translateY(0)" })),
      ]),
      transition(":leave", [animate("300ms ease-in", style({ transform: "translateY(-100%)" }))]),
    ]),
  ],
})
export class SmartAppBannerComponent implements OnInit {
  isVisible = false;
  isIOS = false;
  isAndroid = false;

  readonly IOS_APP_ID = "6756850786";
  readonly ANDROID_PACKAGE = "com.utrav.app";
  readonly ANDROID_PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.utrav.app&hl=fr";

  constructor(private bannerService: SmartAppBannerService) {}

  ngOnInit(): void {
    // Check if banner was permanently dismissed
    if (this.bannerService.isDismissed()) {
      return;
    }

    // Detect platform
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    this.isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    this.isAndroid = /android/i.test(userAgent);

    // Show banner only on mobile devices
    if (this.isIOS || this.isAndroid) {
      // Small delay for better UX
      setTimeout(() => {
        this.isVisible = true;
      }, 500);
    }
  }

  openApp(): void {
    const currentPath = window.location.pathname;

    if (this.isIOS) {
      // Universal Links for iOS
      window.location.href = `https://bo.utrav.ma${currentPath}`;

      // Fallback to App Store after delay if app not installed
      setTimeout(() => {
        window.location.href = `https://apps.apple.com/app/id${this.IOS_APP_ID}`;
      }, 2000);
    } else if (this.isAndroid) {
      // App Links for Android
      window.location.href = `https://bo.utrav.ma${currentPath}`;

      // Fallback to Play Store after delay if app not installed
      setTimeout(() => {
        window.location.href = this.ANDROID_PLAY_STORE_URL;
      }, 2000);
    }
  }

  dismiss(): void {
    this.bannerService.dismiss();
    this.isVisible = false;
  }
}
